// @flow
import { connect } from 'react-redux';

import CompetitionsInternationalesDefaultHeader from 'components/competitionsInternationales/CompetitionsInternationalesDefaultHeader';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/competitionsInternationales/CompetitionsInternationalesDefaultHeader';

export default connect((state: StateType): StateProps => ({
  data: state.competitionsInternationalesState.data
}))(CompetitionsInternationalesDefaultHeader);
